// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lfx-error-alert',
  templateUrl: './error-alert.component.html',
  styleUrls: ['./error-alert.component.scss'],
  standalone: false,
})
export class ErrorAlertComponent implements OnInit {
  @Input() message = '';

  constructor() {}

  ngOnInit(): void {}
}
